import React from 'react';

const TipPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-xl font-semibold mb-4">Enjoyed using our AI features?</h2>
        <p className="text-gray-600 mb-6">
          If you found our AI tools helpful, consider leaving a small tip to support our work! 
          This helps us keep the AI features free for everyone.
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            No thanks
          </button>
          <a
            href="https://buy.stripe.com/6oE17Hb5haLB4RqeUU"
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            onClick={onClose}
          >
            Leave a tip
          </a>
        </div>
      </div>
    </div>
  );
};

export default TipPopup; 